import {ReactElement, ReactNode} from 'react'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'

import {useStyles} from './styles'

type SelectSupportReasonRowProps = {
  title: ReactNode,
  subTitle: ReactNode,
  onClick: () => void,
}

function SelectSupportReasonRow(props: SelectSupportReasonRowProps): ReactElement {
  const classes = useStyles()
  const {title, subTitle, onClick} = props

  return (
    <div className={classes.container} onClick={onClick}>
      <div>
        <div className={classes.title}>{title}</div>
        <div className={classes.subTitle}>{subTitle}</div>
      </div>
      <div>
        <ChevronRightIcon />
      </div>
    </div>
  )
}

export {SelectSupportReasonRow}
